import React from "react";

const Footer = () => {
    return (
        <footer id="footer" className="text-gray-300 bg-secondary font-body">
            <div className="container px-5 py-8 mx-auto text-center lg:px-40">
                <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                    Copyright © Matthew R. Just
                </p>
            </div>
        </footer>
    );
}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.jsx